import { sessionResponseError } from './sessionRecovery';

const headers = (token) => ({ Authorization: `Bearer ${token || ''}` });
export function safeProductURL(value) {
  if (value === '/app/ecommerce') return value;
  const target = new URL(value);
  if (target.protocol !== 'https:' || target.username || target.password) throw new Error('电商入口地址无效，请联系管理员。');
  return target.href;
}
function normalizedEntry(entry) {
  if (!['ecommerce', 'front_desk', 'choose'].includes(entry?.product)) throw new Error('无法识别工作台，请联系管理员。');
  return { product: entry.product, legacy: Boolean(entry.legacy), entry_url: entry.product === 'ecommerce' ? safeProductURL(entry.entry_url) : null };
}
export async function selectProductEntry(product) {
  if (!['ecommerce', 'front_desk'].includes(product)) throw new Error('请选择有效工作台。');
  const token = localStorage.getItem('authToken');
  const response = await fetch('/api/enduser/product-entry', { method: 'POST', headers: { ...headers(token), 'Content-Type': 'application/json' }, body: JSON.stringify({ product }) });
  if (!response.ok) throw sessionResponseError(response, token, '选择未保存，请重试。');
  const entry = normalizedEntry(await response.json());
  if (entry.product !== product) throw new Error('工作台未保存，请重试。');
  return entry;
}
export async function resolveProductEntry() {
  const token = localStorage.getItem('authToken');
  const response = await fetch('/api/enduser/product-entry', { headers: headers(token) });
  if (!response.ok) throw sessionResponseError(response, token, '暂时无法读取业务入口，请重试。');
  const entry = await response.json();
  return normalizedEntry(entry);
}
export function readEntryChallenge(search) {
  const params = new URLSearchParams(search);
  const challenge = params.get('challenge'); const state = params.get('state');
  if (!/^[A-Za-z0-9_-]{43}$/.test(challenge || '') || !/^[A-Za-z0-9_-]{22,128}$/.test(state || '')) throw new Error('登录验证链接无效，请从电商后台重新进入。');
  return { code_challenge: challenge, state };
}
export async function issueProductEntry(payload) {
  const token = localStorage.getItem('authToken');
  const response = await fetch('/api/enduser/ecommerce-entry', { method: 'POST', headers: { ...headers(token), 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
  if (!response.ok) throw sessionResponseError(response, token, '电商账号尚未就绪或登录已失效，请重新登录或联系管理员。');
  const result = await response.json();
  return safeProductURL(result.redirect_url);
}
